export enum EPageType {
  M03y26smb = 'm03y26smb',
  M03y26ab = 'm03y26ab',
  M03y26sob = 'm03y26sob',
  WithRangeM03y26 = 'withRangeM03y26',
  M09y26smb = 'm09y26smb',
  M09y26ab = 'm09y26ab',
  M09y26sob = 'm09y26sob',
  WithRangeM09y26 = 'withRangeM09y26',
}
